export default "__VITE_ASSET__Fz_iRats__"